import logo from '@/assets/logo.png';

export default function Logo() {
  return (
    <div
      data-testid="logo"
      className="flex h-11 items-center justify-between px-6 py-8"
    >
      <div className="flex gap-2">
        <img src={logo} alt="logo Opportunity" className="size-6" />
        <div className="font-semibold uppercase">Opportunity</div>
      </div>
    </div>
  );
}
